import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '../../core/services/cart.service';
import { ToastrService } from 'ngx-toastr';
import { NetworkService } from '../../core/services/network.service';

@Component({
  selector: 'cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CartComponent implements OnInit {
  items;
  total;

  constructor(
    private router: Router,
    private cart: CartService,
    private network: NetworkService,
    private toast: ToastrService
    ) {}

  ngOnInit(): void {
    this.items = this.cart.getCartItems();
    this.total = this.cart.getTotal();
  }

  createOrder () {
    if (this.itemIsDeactivated()) {
      this.toast.error('Please remove deactivated products', 'Error');
      return;
    }
    if (this.items.length) {
      this.network
          .createOrder()
          .then(order => {
            this.router.navigate(['/payment', order.uuid]);
          });
    }
  }

  itemIsDeactivated () {
    let result = false;
    this.items.forEach(item => {
      if (item.states.trashed) {
        return result = true;
      }
    });
    return result;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/cart/cart.component.ts